import React, { useEffect, useState, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import '../Reactions.css';

const basicEmojis = [
    { type: 'like', emoji: '👍', allow: true, priv: 0 },
    { type: 'heart', emoji: '❤️', allow: true, priv: 0 },
    { type: 'bheart', emoji: '💙️', allow: false, priv: 0 },
    { type: 'haha', emoji: '😆', allow: true, priv: 0 },
    { type: 'sad', emoji: '😢', allow: true, priv: 0 },
    { type: 'angry', emoji: '😠', allow: true, priv: 0 },
    { type: 'dislike', emoji: '👎', allow: false, priv: 0 },
    { type: 'present', emoji: '🎁', allow: false, priv: 0 },
    { type: 'pinkheart', emoji: '🩷', allow: true, priv: 351 }, //Grace
    { type: 'fuck', emoji: '🖕', allow: true, priv: 351 }, //Grace
    { type: 'purpleheart', emoji: '💜', allow: true, priv: 563 }, //Sylv
    { type: 'skull', emoji: '💀', allow: true, priv: 600 }, //Ave (stokly)
];

const extendedEmojis = [
    ...basicEmojis,
    { type: 'skull', emoji: '💀', allow: false, priv: 0 },
    { type: 'hot', emoji: '🥵', allow: true, priv: 0 },
    { type: 'surprised', emoji: '😲', allow: true, priv: 0 },
    { type: 'poop', emoji: '💩', allow: true, priv: 0 },
    { type: 'blah', emoji: '🤮', allow: true, priv: 0 },
    { type: 'ufo', emoji: '👽', allow: false, priv: 0 },
    { type: 'clown', emoji: '🤡', allow: false, priv: 0 },
    { type: 'fuck', emoji: '🖕', allow: false, priv: 0 },
    { type: 'sparkles', emoji: '✨', allow: false, priv: 0 },
    { type: 'lgbt', emoji: '🏳️‍🌈', allow: true, priv: 0 },
    { type: 'doublehearts', emoji: '💕', allow: true, priv: 173 }, //Zoe
    { type: 'dog', emoji: '🐶', allow: false, priv: 0 },
    { type: 'heart2', emoji: '💗', allow: true, priv: 535 }, //Mirren
];

const PostReactions = ({ postId, aiLikeCount = 0, aiHeartCount = 0 }) => {
    const [emojiOptions, setEmojiOptions] = useState(basicEmojis);
    const [reactions, setReactions] = useState({});
    const [tooltipVisible, setTooltipVisible] = useState(null);
    const [tooltipData, setTooltipData] = useState({});
    const userDataJ = localStorage.getItem('echo_user_data');
    const userData = JSON.parse(userDataJ);
    const nodeRefs = useRef({});

    // 👉 Vyber emojis podle oprávnění
    useEffect(() => {
        const acc = parseInt(localStorage.getItem("echo_user_account_type") || '0', 10);
        if (acc >= 1) {
            setEmojiOptions(extendedEmojis);
        } else {
            setEmojiOptions(basicEmojis);
        }
    }, []);

    // 🧠 Refs pro animace
    emojiOptions.forEach(({ type }) => {
        if (!nodeRefs.current[type]) {
            nodeRefs.current[type] = React.createRef();
        }
    });

    // 🔄 Načti reakce
    const fetchReactions = async () => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/reactions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ post: postId }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                setReactions(data.reactions);
                setTooltipData(data.names);
            }
        } catch (err) {
            console.error('Chyba při načítání reakcí:', err);
        }
    };

    // ❤️ Reakce
    const handleReact = async (type) => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/react.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    post: postId,
                    user: localStorage.getItem("echo_user"),
                    emoji: type,
                }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                fetchReactions();
            }
        } catch (err) {
            console.error('Chyba při odesílání reakce:', err);
        }
    };

    useEffect(() => {
        fetchReactions();
    }, [postId]);

    return (
        <div className="d-flex align-items-center gap-2 mt-3 position-relative">
            <TransitionGroup className="d-flex align-items-center gap-2">
                {emojiOptions.map(({ type, emoji }) => {
                    const real = parseInt(reactions[type]?.count || '0', 10);
                    //const ai = type === 'like' ? parseInt(aiLikeCount || '0', 10) : 0;
                    const ai   = type === 'like'
                        ? parseInt(aiLikeCount, 10)
                        : type === 'heart'
                            ? parseInt(aiHeartCount, 10)
                            : 0;
                    const total = real + ai;

                    if (total === 0) return null;

                    const names = tooltipData[type]?.join(', ') || '';
                    const tooltip = (() => {
                        if (ai > 0) {
                            if (!names) {
                                return `${ai} ${ai === 1 ? 'neznámý' : ai <= 4 ? 'neznámí' : 'neznámých'}`;
                            } else {
                                return `${names} a ${ai === 1 ? '1 další' : `${ai} dalších`}`;
                            }
                        }

                        return names || 'Nikdo';
                    })();

                    return (
                        <CSSTransition
                            key={type}
                            timeout={200}
                            classNames="reaction-anim"
                            nodeRef={nodeRefs.current[type]}
                        >
                            <div ref={nodeRefs.current[type]}>
                                <span
                                    className="reaction-btn position-relative"
                                    style={{ cursor: 'pointer', fontSize: '1.2rem' }}
                                    onMouseEnter={() => setTooltipVisible(type)}
                                    onMouseLeave={() => setTooltipVisible(null)}
                                >
                                    {emoji} {total}
                                    {tooltipVisible === type && (
                                        <div className="custom-tooltip">{tooltip}</div>
                                    )}
                                </span>
                            </div>
                        </CSSTransition>
                    );
                })}
            </TransitionGroup>

            {/* Výběr nové reakce */}
            <div
                className="d-flex flex-wrap gap-2 ms-3 bg-echolight p-2 rounded"
                style={{maxWidth: '100%'}}
            >
                {emojiOptions.map(({type, emoji, allow, priv}) => (
                    ((priv > 0 && userData.id == priv || priv == 0 ) && allow ?
                        <span
                            key={type}
                            onClick={() => handleReact(type)}
                            className="reaction-picker"
                            style={{cursor: 'pointer', fontSize: '1.4rem'}}
                            title={`Reagovat: ${emoji}`}
                        >
                          {emoji}
                        </span> : null
                    )
                    ))}
            </div>

        </div>
    );
};

export default PostReactions;
